const tpBaseData = {
  assessItem: '考核项目',
  versionNo: '版本号',
  isEffective: '是否生效',
  category: '分类',
  assessContent: '考核内容',
  citationBasis: '援引依据',
  score: '分值',
  breachExample: '违约示例描述',
  msg: {}
};
export default tpBaseData;



// WEBPACK FOOTER //
// ./src/page/assess/tpBaseData/lang/tpBaseData.zh.js